import React from "react";
import { motion } from "framer-motion";
import refferFriend_banner from '../../Assets/images/home/refferFriend_banner.png'
import { toast } from "react-toastify";

const LearnMore = () => {
  const motionVariantsTop = {
    hidden: { opacity: 0, y: -40 },
    visible: { opacity: 1, y: 0 },
  };

  const motionProperties = {
    initial: "hidden",
    whileInView: "visible",
    transition: { duration: 1, delay: 0.5 },
    viewport: { once: true },
  };

   const websiteUrl = "https://learn.techmentee.com/";

   const handelShare = async()=>{
    if(navigator.share){
      try {
        await navigator.share({
          title :"Check out this website" ,
          text : "Hey! Check out this website.",
          url : websiteUrl
        });
        
      } catch (error) {
        console.log("Share Cancelled");
      }
    }
    else {
      await navigator.clipboard.writeText(websiteUrl);
      toast.error("Website link copied!");
    }
   }


  return (
    <React.Fragment>
      <div className="w-full h-auto overflow-hidden" style={{ backgroundImage: `url(${refferFriend_banner})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'right' }}>
        <motion.div
          variants={motionVariantsTop}
          {...motionProperties}
          className="mx-auto max-w-7xl px-12 py-20 sm:px-6 lg:px-8"
        >
          <div className="flex items-center justify-center">
            <div className="text-center">
              <h1 className="text-white font-medium lg:text-2xl text-xl tracking-wider uppercase">
                LEARN MORE ABOUT OUR REFER-A-FRIEND PROGRAM.
              </h1>
              <p className="mt-6 text-white md:w-[70%] m-auto">
                Invite friends to join us and earn rewards! Get a bonus for each
                friend who signs up and meets the requirements. Thank you for
                spreading the word!
              </p>
            </div>
          </div>

          <div className="mt-6 flex justify-start">
              <button onClick={handelShare} className="text-white text-[15px] font-medium text-center bg-primaryOrangeColor py-2 px-2 md:w-[20%] w-full rounded-full m-auto">
                Refer Your Friend
              </button>
          </div>
        </motion.div>
      </div>
    </React.Fragment>
  );
};

export default LearnMore;
